export const globals = {
    traceId: <string>undefined,
    workflowUrl: <string>undefined,
    decryptedParams: <string>undefined,
    brandName: <string>undefined,
    viewMessage: <string>undefined,
    customerid: <string>undefined,
    emailAddress: <string>undefined,
    locale: <string>undefined
};
